import React,{useState,useEffect} from 'react'
import { getMoneyOwedNext3Events } from 'network/ApiAxiosTickets';
import { Row, Col } from 'react-bootstrap';

function NextEventsOwed(props) {
    const [money, setMoney] = useState(0);
    let userID = JSON.parse(localStorage.getItem("user"))._id;
    let userName = JSON.parse(localStorage.getItem("user")).name;
    useEffect(() => {
        fetchSellerDeposits()
    }, []);

    const fetchSellerDeposits = async()=>{
        const resp = await getMoneyOwedNext3Events(userID)
        if(resp.data.success){
          setMoney(resp.data.events)
        }
    }
  return (
    money ?
      <Row>
        {money.map((eventItem)=>{
          return <Row className='w-100'>
            <Col xs={12} md={6} className="text-center">
              <img src={'https://new.geticketsonline.com/files/product-images/' + eventItem.posterImage} alt={eventItem.name} style={{width: '100px', height: '100px'}} />
              <p>{eventItem.name.length > 30 ? eventItem.name : eventItem.name + ' ' + eventItem.checkinFrom.split('T')[0]}</p>
            </Col>
            <Col xs={12} md={6} className="text-center align-content-center">
              <h4>Tickets sold: {eventItem.tickets}</h4>
              <h4>Total sold: {eventItem.total}€</h4>
            </Col>
          </Row>
        })
        }
      </Row> : null
  )
}

export default NextEventsOwed